/**
 * Enum for label format in Fibonacci tools, which determines how the label is rendered
 * @readonly
 * @enum {string}
 */
export const FibToolLabelFormat = {
	/** Display the labels using a decimal representation */
	DECIMAL: 'decimal',
	/** Display the labels using a percentage representation */
	PERCENT: 'percent'
};

export default {
	FibToolLabelFormat
};
